export default __webpack_public_path__ + "static/media/Circleci.21dabe0d.svg";